// Re-compilation trigger
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAdmin } from '../../context/AdminContext';
import { useAuth } from '../../context/AuthContext';
import { useAlert } from '../../context/AlertContext';
import { Save, Settings as SettingsIcon, Shield, Percent, User, Lock, Building2, Megaphone, Share2, Plus, Trash2, Pencil, GripVertical, ExternalLink, ToggleLeft, ToggleRight } from 'lucide-react';
import API_BASE_URL from '../../config/api';
import AdminPinModal from '../../components/AdminPinModal';
import apiService from '../../services/apiService';

// Social Media SVG Icon component
const SocialIcon = ({ platform, color = 'currentColor', size = 20 }) => {
    const icons = {
        facebook: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
        ),
        instagram: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
            </svg>
        ),
        x: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
        ),
        youtube: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
        ),
        whatsapp: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
        ),
        linkedin: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
        ),
        telegram: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
            </svg>
        ),
        pinterest: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641 0 12.017 0z"/>
            </svg>
        ),
        threads: (
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
                <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.59 12c.025 3.086.718 5.496 2.057 7.164 1.432 1.781 3.632 2.695 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.187.408-2.26 1.33-3.017.88-.723 2.11-1.134 3.562-1.19 1.07-.038 2.058.076 2.94.338-.093-.702-.334-1.26-.723-1.666-.508-.53-1.27-.81-2.27-.835l-.08-.002c-.763 0-1.455.197-2.003.57-.426.29-.698.648-.816.93l-1.836-.726c.199-.505.603-1.065 1.227-1.525.854-.63 1.95-.964 3.167-.976h.116c1.564.032 2.803.501 3.682 1.393.702.712 1.14 1.634 1.313 2.756.426.107.836.238 1.227.393 1.205.48 2.145 1.264 2.72 2.261.71 1.228.898 2.933.202 4.616-.895 2.16-2.904 3.428-6.058 3.611-.207.012-.41.017-.607.017zm-1.065-8.254c-.104 0-.21.003-.317.01-1.045.056-1.857.328-2.418.81-.536.461-.79 1.043-.756 1.729.048.903.48 1.5 1.283 1.775.536.183 1.178.267 1.9.232 1.15-.063 2.028-.464 2.608-1.187.476-.594.783-1.404.907-2.397-.654-.236-1.395-.38-2.207-.43-.34-.022-.671-.035-.99-.042h-.01z"/>
            </svg>
        ),
    };

    return icons[platform] || (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
    );
};

const Settings = () => {
    const navigate = useNavigate();
    const { updateSettings } = useAdmin();
    const { user } = useAuth();
    const { showAlert } = useAlert();
    const [localSettings, setLocalSettings] = useState({
        company_name: '',
        support_email: '',
        company_phone: '',
        company_address: '',
        currency: 'INR',
        timezone: 'IST',
        admin_fee: '0',
        tds: '0',
        min_withdrawal: '0',
        announcement_text: '',
        announcement_enabled: '0',
        admin_security_pin: '1234'
    });
    const [bankDetails, setBankDetails] = useState({
        bank_account_holder: '',
        bank_account_number: '',
        bank_name: '',
        bank_ifsc: '',
        bank_branch: ''
    });
    const [adminProfile, setAdminProfile] = useState({
        name: user?.name || 'Admin',
        email: user?.email || '',
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [savingProfile, setSavingProfile] = useState(false);
    const [savingSettings, setSavingSettings] = useState(false);
    const [savingBank, setSavingBank] = useState(false);
    const [showPinModal, setShowPinModal] = useState(false);

    // Social Links State
    const [socialLinks, setSocialLinks] = useState([]);
    const [loadingSocial, setLoadingSocial] = useState(false);
    const [savingSocial, setSavingSocial] = useState(false);
    const [editingSocialLink, setEditingSocialLink] = useState(null);
    const [socialForm, setSocialForm] = useState({
        platform: 'facebook',
        url: '',
        icon: 'facebook',
        display_order: 0,
        is_active: 1,
        username: '',
        whatsapp_number: '',
        whatsapp_message: 'Hello! I would like to know more about Swift2ai Lifecare products.'
    });
    const [showSocialForm, setShowSocialForm] = useState(false);

    const SOCIAL_PLATFORMS = [
        { value: 'facebook', label: 'Facebook', color: '#1877F2', prefix: 'https://facebook.com/', handleLabel: 'Username' },
        { value: 'instagram', label: 'Instagram', color: '#E4405F', prefix: 'https://instagram.com/', handleLabel: 'Username' },
        { value: 'x', label: 'X (Twitter)', color: '#000000', prefix: 'https://x.com/', handleLabel: 'Username' },
        { value: 'youtube', label: 'YouTube', color: '#FF0000', prefix: 'https://youtube.com/@', handleLabel: 'Channel Handle' },
        { value: 'whatsapp', label: 'WhatsApp', color: '#25D366', prefix: 'https://wa.me/', handleLabel: 'Phone Number' },
        { value: 'linkedin', label: 'LinkedIn', color: '#0A66C2', prefix: 'https://linkedin.com/in/', handleLabel: 'Profile ID' },
        { value: 'telegram', label: 'Telegram', color: '#26A5E4', prefix: 'https://t.me/', handleLabel: 'Username' },
        { value: 'pinterest', label: 'Pinterest', color: '#BD081C', prefix: 'https://pinterest.com/', handleLabel: 'Username' },
        { value: 'threads', label: 'Threads', color: '#000000', prefix: 'https://threads.net/@', handleLabel: 'Username' },
    ];

    // Fetch settings from database
    const fetchSettings = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/system_settings.php`);
            const data = await response.json();
            if (data.success && data.data) {
                setLocalSettings(prev => ({
                    ...prev,
                    company_name: data.data.company_name || '',
                    support_email: data.data.support_email || '',
                    company_phone: data.data.company_phone || '',
                    company_address: data.data.company_address || '',
                    currency: data.data.currency || 'INR',
                    timezone: data.data.timezone || 'IST',
                    admin_fee: data.data.admin_fee || '0',
                    tds: data.data.tds || '0',
                    min_withdrawal: data.data.min_withdrawal || '0',
                    announcement_text: data.data.announcement_text || '',
                    announcement_enabled: data.data.announcement_enabled || '0',
                    admin_security_pin: data.data.admin_security_pin || '1234'
                }));
                setBankDetails({
                    bank_account_holder: data.data.bank_account_holder || '',
                    bank_account_number: data.data.bank_account_number || '',
                    bank_name: data.data.bank_name || '',
                    bank_ifsc: data.data.bank_ifsc || '',
                    bank_branch: data.data.bank_branch || ''
                });
            }
        } catch (error) {
            console.error('Failed to fetch settings:', error);
        }
    }, []);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    // Fetch social links
    const fetchSocialLinks = useCallback(async () => {
        setLoadingSocial(true);
        try {
            const data = await apiService.getSocialLinks(true);
            if (data.success) {
                setSocialLinks(data.data || []);
            }
        } catch (error) {
            console.error('Failed to fetch social links:', error);
        } finally {
            setLoadingSocial(false);
        }
    }, []);

    useEffect(() => {
        fetchSocialLinks();
    }, [fetchSocialLinks]);

    const handleSocialFormChange = (e) => {
        const { name, value } = e.target;
        setSocialForm(prev => ({
            ...prev,
            [name]: value,
            ...(name === 'platform' ? { icon: value, url: '', whatsapp_number: '', whatsapp_message: prev.whatsapp_message } : {})
        }));
    };

    const resetSocialForm = () => {
        setSocialForm({
            platform: 'facebook',
            url: '',
            icon: 'facebook',
            display_order: 0,
            is_active: 1,
            username: '',
            whatsapp_number: '',
            whatsapp_message: 'Hello! I would like to know more about Swift2ai Lifecare products.'
        });
        setEditingSocialLink(null);
        setShowSocialForm(false);
    };

    const handleSaveSocialLink = async () => {
        let finalForm = { ...socialForm };
        const platformInfo = SOCIAL_PLATFORMS.find(p => p.value === socialForm.platform);

        if (socialForm.platform === 'whatsapp') {
            const num = socialForm.whatsapp_number.replace(/[^0-9]/g, '');
            if (!num) {
                showAlert('Please enter a WhatsApp phone number', 'error');
                return;
            }
            const msg = encodeURIComponent(socialForm.whatsapp_message || '');
            finalForm.url = `https://wa.me/${num}${msg ? '?text=' + msg : ''}`;
        } else if (platformInfo) {
            const cleanHandle = socialForm.username.trim()
                .replace(/^@/, '') // remove leading @ if entered
                .replace(platformInfo.prefix, ''); // remove prefix if full URL was pasted
            
            if (!cleanHandle) {
                showAlert(`Please enter ${platformInfo.handleLabel}`, 'error');
                return;
            }
            finalForm.url = `${platformInfo.prefix}${cleanHandle}`;
        }

        setSavingSocial(true);
        try {
            const payload = {
                platform: finalForm.platform,
                url: finalForm.url,
                icon: finalForm.icon,
                display_order: finalForm.display_order,
                is_active: finalForm.is_active
            };
            if (editingSocialLink) {
                await apiService.updateSocialLink({ id: editingSocialLink, ...payload });
                showAlert('Social link updated successfully!', 'success');
            } else {
                await apiService.createSocialLink(payload);
                showAlert('Social link added successfully!', 'success');
            }
            resetSocialForm();
            fetchSocialLinks();
        } catch (error) {
            showAlert(error.message || 'Failed to save social link', 'error');
        } finally {
            setSavingSocial(false);
        }
    };

    const handleEditSocialLink = (link) => {
        setEditingSocialLink(link.id);
        const platformInfo = SOCIAL_PLATFORMS.find(p => p.value === link.platform);
        
        let waNumber = '';
        let waMessage = 'Hello! I would like to know more about Swift2ai Lifecare products.';
        let username = '';

        if (link.platform === 'whatsapp' && link.url) {
            try {
                const waUrl = new URL(link.url);
                waNumber = waUrl.pathname.replace('/', '');
                waMessage = waUrl.searchParams.get('text') || waMessage;
            } catch (e) {
                const match = link.url.match(/wa\.me\/([0-9]+)/);
                if (match) waNumber = match[1];
                const textMatch = link.url.match(/[?&]text=([^&]*)/);
                if (textMatch) waMessage = decodeURIComponent(textMatch[1]);
            }
        } else if (platformInfo && link.url) {
            username = link.url.replace(platformInfo.prefix, '');
        }

        setSocialForm({
            platform: link.platform,
            url: link.url,
            icon: link.icon || link.platform,
            display_order: link.display_order || 0,
            is_active: parseInt(link.is_active),
            whatsapp_number: waNumber,
            whatsapp_message: waMessage,
            username: username
        });
        setShowSocialForm(true);
    };

    const handleDeleteSocialLink = async (id) => {
        if (!window.confirm('Are you sure you want to delete this social link?')) return;
        try {
            await apiService.deleteSocialLink(id);
            showAlert('Social link deleted!', 'success');
            fetchSocialLinks();
        } catch (error) {
            showAlert(error.message || 'Failed to delete social link', 'error');
        }
    };

    const handleToggleSocialLink = async (link) => {
        try {
            await apiService.updateSocialLink({
                id: link.id,
                is_active: parseInt(link.is_active) === 1 ? 0 : 1
            });
            fetchSocialLinks();
        } catch (error) {
            showAlert(error.message || 'Failed to toggle social link', 'error');
        }
    };

    const getPlatformColor = (platform) => {
        const p = SOCIAL_PLATFORMS.find(pl => pl.value === platform);
        return p ? p.color : '#6B7280';
    };

    const getPlatformLabel = (platform) => {
        const p = SOCIAL_PLATFORMS.find(pl => pl.value === platform);
        return p ? p.label : platform;
    };

    useEffect(() => {
        setAdminProfile(prev => ({
            ...prev,
            name: user?.name || 'Admin',
            email: user?.email || ''
        }));
    }, [user]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setLocalSettings({
            ...localSettings,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleProfileChange = (e) => {
        const { name, value } = e.target;
        setAdminProfile({
            ...adminProfile,
            [name]: value
        });
    };

    const handleSaveProfile = async () => {
        if (adminProfile.newPassword) {
            if (adminProfile.newPassword !== adminProfile.confirmPassword) {
                showAlert('Passwords do not match', 'error');
                return;
            }
            if (adminProfile.newPassword.length < 6) {
                showAlert('Password must be at least 6 characters', 'error');
                return;
            }
        }

        setSavingProfile(true);
        try {
            const token = localStorage.getItem('authToken');
            const updateData = {
                name: adminProfile.name
            };

            if (adminProfile.newPassword) {
                updateData.currentPassword = adminProfile.currentPassword;
                updateData.newPassword = adminProfile.newPassword;
            }

            const response = await fetch(`${API_BASE_URL}/admin/update_profile.php`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(updateData)
            });

            const data = await response.json();

            if (data.success) {
                showAlert('Profile updated successfully!', 'success');

                // FORCE UPDATE LOCAL STORAGE
                const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
                const updatedUser = {
                    ...currentUser,
                    name: adminProfile.name,
                    // If backend sends specific user data, use that, otherwise trust frontend state
                    user_id: adminProfile.name // Since we are using user_id as name for admin
                };
                localStorage.setItem('user', JSON.stringify(updatedUser));

                setAdminProfile(prev => ({
                    ...prev,
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                }));

                // Reload to refresh context with new localStorage data
                window.location.reload();
            } else {
                showAlert(data.message || 'Failed to update profile', 'error');
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            showAlert('Failed to update profile', 'error');
        } finally {
            setSavingProfile(false);
        }
    };

    const handleSaveGeneral = useCallback(async () => {
        setSavingSettings(true);
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}/admin/system_settings.php`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    company_name: localSettings.company_name,
                    support_email: localSettings.support_email,
                    company_phone: localSettings.company_phone,
                    company_address: localSettings.company_address,
                    currency: localSettings.currency,
                    timezone: localSettings.timezone,
                    admin_security_pin: localSettings.admin_security_pin
                })
            });
            const data = await response.json();
            if (data.success) {
                showAlert('General settings saved successfully!', 'success');
                updateSettings(localSettings);
            } else {
                showAlert(data.message || 'Failed to save settings', 'error');
            }
        } catch (error) {
            showAlert('Failed to save settings', 'error');
        } finally {
            setSavingSettings(false);
        }
    }, [localSettings, updateSettings, showAlert]);

    const handlePinUpdateClick = useCallback(() => {
        if (!localSettings.admin_security_pin || localSettings.admin_security_pin.length !== 4) {
            showAlert('Please enter a valid 4-digit PIN first', 'error');
            return;
        }
        setShowPinModal(true);
    }, [localSettings.admin_security_pin, showAlert]);

    const onVerifySuccessForPinChange = useCallback(() => {
        handleSaveGeneral();
    }, [handleSaveGeneral]);

    const handleSaveFinancial = async () => {
        setSavingSettings(true);
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}/admin/system_settings.php`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    admin_fee: localSettings.admin_fee,
                    tds: localSettings.tds,
                    min_withdrawal: localSettings.min_withdrawal
                })
            });
            const data = await response.json();
            if (data.success) {
                showAlert('Financial settings updated!', 'success');
            } else {
                showAlert(data.message || 'Failed to update', 'error');
            }
        } catch (error) {
            showAlert('Failed to update settings', 'error');
        } finally {
            setSavingSettings(false);
        }
    };

    const handleSaveBank = async () => {
        setSavingBank(true);
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}/admin/system_settings.php`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(bankDetails)
            });
            const data = await response.json();
            if (data.success) {
                showAlert('Bank details saved successfully!', 'success');
            } else {
                showAlert(data.message || 'Failed to save bank details', 'error');
            }
        } catch (error) {
            showAlert('Failed to save bank details', 'error');
        } finally {
            setSavingBank(false);
        }
    };


    const handleBankChange = (e) => {
        const { name, value } = e.target;
        setBankDetails(prev => ({ ...prev, [name]: value }));
    };

    return (
        <Layout>
            <div className="space-y-6">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900">System Settings</h1>
                    <p className="text-gray-500 text-sm mt-1">Configure global application parameters</p>
                </div>

                {/* Admin Profile Section */}
                <div className="bg-gradient-to-br from-purple-500 to-indigo-600 rounded-2xl shadow-lg p-6 text-white">
                    <div className="flex items-center gap-3 mb-6">
                        <User size={28} />
                        <div>
                            <h2 className="text-xl font-bold">Admin Profile</h2>
                            <p className="text-purple-100 text-sm">Update your name and password</p>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-semibold text-purple-100 mb-2">Admin Name</label>
                            <input
                                type="text"
                                name="name"
                                value={adminProfile.name}
                                onChange={handleProfileChange}
                                className="w-full px-4 py-2 bg-white/20 border border-white/30 rounded-xl text-white placeholder-purple-200 focus:ring-2 focus:ring-white/50 focus:outline-none"
                                placeholder="Enter your name"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-purple-100 mb-2">Email (Read-only)</label>
                            <input
                                type="email"
                                value={adminProfile.email}
                                disabled
                                className="w-full px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-purple-200 cursor-not-allowed"
                            />
                        </div>
                    </div>

                    <div className="mt-6 pt-6 border-t border-white/20">
                        <div className="flex items-center gap-2 mb-4">
                            <Lock size={20} />
                            <h3 className="font-bold">Change Password</h3>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                                <label className="block text-sm font-semibold text-purple-100 mb-2">Current Password</label>
                                <input
                                    type="password"
                                    name="currentPassword"
                                    value={adminProfile.currentPassword}
                                    onChange={handleProfileChange}
                                    className="w-full px-4 py-2 bg-white/20 border border-white/30 rounded-xl text-white placeholder-purple-200 focus:ring-2 focus:ring-white/50 focus:outline-none"
                                    placeholder="••••••"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-purple-100 mb-2">New Password</label>
                                <input
                                    type="password"
                                    name="newPassword"
                                    value={adminProfile.newPassword}
                                    onChange={handleProfileChange}
                                    className="w-full px-4 py-2 bg-white/20 border border-white/30 rounded-xl text-white placeholder-purple-200 focus:ring-2 focus:ring-white/50 focus:outline-none"
                                    placeholder="••••••"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-purple-100 mb-2">Confirm Password</label>
                                <input
                                    type="password"
                                    name="confirmPassword"
                                    value={adminProfile.confirmPassword}
                                    onChange={handleProfileChange}
                                    className="w-full px-4 py-2 bg-white/20 border border-white/30 rounded-xl text-white placeholder-purple-200 focus:ring-2 focus:ring-white/50 focus:outline-none"
                                    placeholder="••••••"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end mt-6">
                        <button
                            onClick={handleSaveProfile}
                            disabled={savingProfile}
                            className="px-6 py-2 bg-white text-purple-600 font-semibold rounded-xl hover:bg-purple-50 transition flex items-center gap-2 disabled:opacity-50"
                        >
                            <Save size={18} />
                            {savingProfile ? 'Saving...' : 'Save Profile'}
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* General Settings */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-6">
                        <div className="flex items-center gap-3 border-b border-gray-100 pb-4">
                            <SettingsIcon className="text-blue-600" size={24} />
                            <h3 className="text-lg font-bold text-gray-900">General Configuration</h3>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Company Name</label>
                                <input
                                    type="text"
                                    name="company_name"
                                    value={localSettings.company_name || ''}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Support Email</label>
                                <input
                                    type="email"
                                    name="support_email"
                                    value={localSettings.support_email || ''}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Company Phone / Mobile</label>
                                <input
                                    type="text"
                                    name="company_phone"
                                    value={localSettings.company_phone || ''}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                />
                            </div>
                            <div className="md:col-span-2">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Company Address</label>
                                <textarea
                                    name="company_address"
                                    value={localSettings.company_address || ''}
                                    onChange={handleChange}
                                    rows={3}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Currency Symbol</label>
                                <select
                                    name="currency"
                                    value={localSettings.currency || 'INR'}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white"
                                >
                                    <option value="INR">₹ (INR)</option>
                                    <option value="USD">$ (USD)</option>
                                    <option value="EUR">€ (EUR)</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Timezone</label>
                                <select
                                    name="timezone"
                                    value={localSettings.timezone || 'IST'}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white"
                                >
                                    <option value="IST">Asia/Kolkata (GMT+5:30)</option>
                                    <option value="UTC">UTC (GMT+0)</option>
                                </select>
                            </div>
                        </div>

                        <div className="flex justify-end">
                            <button
                                onClick={handleSaveGeneral}
                                disabled={savingSettings}
                                className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition flex items-center gap-2 disabled:opacity-50"
                            >
                                <Save size={18} /> {savingSettings ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    </div>

                    {/* Financial Settings */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-6">
                        <div className="flex items-center gap-3 border-b border-gray-100 pb-4">
                            <Percent className="text-green-600" size={24} />
                            <h3 className="text-lg font-bold text-gray-900">Commissions & Tax</h3>
                        </div>

                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Admin Fee (%)</label>
                                <input
                                    type="number"
                                    name="admin_fee"
                                    value={localSettings.admin_fee || 0}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">TDS / Tax Deduction (%)</label>
                                <input
                                    type="number"
                                    name="tds"
                                    value={localSettings.tds || 0}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Min Withdrawal Limit</label>
                                <input
                                    type="number"
                                    name="min_withdrawal"
                                    value={localSettings.min_withdrawal || 0}
                                    onChange={handleChange}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:outline-none"
                                />
                            </div>
                        </div>

                        <button
                            onClick={handleSaveFinancial}
                            disabled={savingSettings}
                            className="w-full px-6 py-2 bg-green-600 text-white font-semibold rounded-xl hover:bg-green-700 transition disabled:opacity-50"
                        >
                            {savingSettings ? 'Saving...' : 'Update Financials'}
                        </button>
                    </div>

                    {/* Company Bank Details */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-6">
                        <div className="flex items-center gap-3 border-b border-gray-100 pb-4">
                            <Building2 className="text-purple-600" size={24} />
                            <h3 className="text-lg font-bold text-gray-900">Company Bank Details</h3>
                        </div>

                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">Account Holder Name</label>
                                <input
                                    type="text"
                                    name="bank_account_holder"
                                    value={bankDetails.bank_account_holder || ''}
                                    onChange={handleBankChange}
                                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                />
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">Account Number</label>
                                    <input
                                        type="text"
                                        name="bank_account_number"
                                        value={bankDetails.bank_account_number || ''}
                                        onChange={handleBankChange}
                                        className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">Bank Name</label>
                                    <input
                                        type="text"
                                        name="bank_name"
                                        value={bankDetails.bank_name || ''}
                                        onChange={handleBankChange}
                                        className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">IFSC Code</label>
                                    <input
                                        type="text"
                                        name="bank_ifsc"
                                        value={bankDetails.bank_ifsc || ''}
                                        onChange={handleBankChange}
                                        className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">Branch Name</label>
                                    <input
                                        type="text"
                                        name="bank_branch"
                                        value={bankDetails.bank_branch || ''}
                                        onChange={handleBankChange}
                                        className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:outline-none"
                                    />
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={handleSaveBank}
                            disabled={savingBank}
                            className="w-full px-6 py-2 bg-purple-600 text-white font-semibold rounded-xl hover:bg-purple-700 transition disabled:opacity-50"
                        >
                            {savingBank ? 'Saving...' : 'Save Bank Details'}
                        </button>
                    </div>

                    {/* Security Settings */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 lg:col-span-2 space-y-6">
                        <div className="flex items-center gap-3 border-b border-gray-100 pb-4">
                            <Shield className="text-purple-600" size={24} />
                            <h3 className="text-lg font-bold text-gray-900">Security & Access</h3>
                        </div>

                        <div className="flex flex-col md:flex-row justify-between items-center gap-4 p-4 bg-gray-50 rounded-xl border border-gray-100">
                            <div>
                                <h4 className="font-bold text-gray-900">Two-Factor Authentication (2FA)</h4>
                                <p className="text-sm text-gray-500">Enforce 2FA for all admin accounts</p>
                            </div>
                            <div className="relative inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
                                <input type="checkbox" name="toggle" id="toggle" className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer border-gray-300" />
                                <label htmlFor="toggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
                            </div>
                        </div>

                        <div className="flex flex-col md:flex-row justify-between items-center gap-4 p-4 bg-gray-50 rounded-xl border border-gray-100">
                            <div>
                                <h4 className="font-bold text-gray-900">New User Registration</h4>
                                <p className="text-sm text-gray-500">Allow new users to register on the platform</p>
                            </div>
                            <div className="w-12 h-6 bg-green-500 rounded-full relative cursor-pointer">
                                <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full shadow-sm"></div>
                            </div>
                        </div>
                    </div>

                    {/* Announcement Settings Redirect */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 lg:col-span-2 overflow-hidden relative group">
                        <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:scale-110 transition-transform duration-500">
                            <Megaphone size={120} className="text-orange-600" />
                        </div>
                        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
                            <div className="flex-1 space-y-4 text-center md:text-left">
                                <div className="inline-flex items-center gap-2 px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-bold uppercase tracking-wider">
                                    New Feature
                                </div>
                                <h3 className="text-2xl font-black text-gray-900 tracking-tight">Dashboard Announcements (Notice Board)</h3>
                                <p className="text-gray-500 font-medium max-w-xl">
                                    We have upgraded our announcement system! You can now post **multiple notices** with different categories (Info, Success, Warning, Danger) that will rotate on the user dashboard.
                                </p>
                            </div>
                            <button
                                onClick={() => navigate('/admin/notices')}
                                className="px-8 py-4 bg-orange-600 text-white font-bold rounded-2xl hover:bg-orange-700 shadow-xl shadow-orange-100 transition-all flex items-center gap-3 active:scale-95 shrink-0"
                            >
                                <Megaphone size={24} /> Manage Announcements
                            </button>
                        </div>
                    </div>
                </div>

                {/* Social Media Links Management */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-6">
                    <div className="flex items-center justify-between border-b border-gray-100 pb-4">
                        <div className="flex items-center gap-3">
                            <Share2 className="text-pink-600" size={24} />
                            <div>
                                <h3 className="text-lg font-bold text-gray-900">Social Media Links</h3>
                                <p className="text-xs text-gray-500">Manage social media icons shown in the website footer</p>
                            </div>
                        </div>
                        <button
                            onClick={() => { resetSocialForm(); setShowSocialForm(!showSocialForm); }}
                            className="px-4 py-2 bg-pink-600 text-white font-semibold rounded-xl hover:bg-pink-700 transition flex items-center gap-2 text-sm"
                        >
                            <Plus size={16} /> Add Link
                        </button>
                    </div>

                    {/* Add / Edit Form */}
                    {showSocialForm && (
                        <div className="p-5 bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl border border-pink-100 space-y-4">
                            <h4 className="font-bold text-gray-800 text-sm flex items-center gap-2">
                                {editingSocialLink ? <Pencil size={16} /> : <Plus size={16} />}
                                {editingSocialLink ? 'Edit Social Link' : 'Add New Social Link'}
                            </h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">Platform</label>
                                    <select
                                        name="platform"
                                        value={socialForm.platform}
                                        onChange={handleSocialFormChange}
                                        className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-pink-500 focus:outline-none bg-white text-sm font-medium"
                                    >
                                        {SOCIAL_PLATFORMS.map(p => (
                                            <option key={p.value} value={p.value}>{p.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">Display Order</label>
                                    <input
                                        type="number"
                                        name="display_order"
                                        value={socialForm.display_order}
                                        onChange={handleSocialFormChange}
                                        min="0"
                                        className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-pink-500 focus:outline-none text-sm"
                                        placeholder="0"
                                    />
                                </div>
                            </div>
                            {socialForm.platform === 'whatsapp' ? (
                                <>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-600 mb-1.5">WhatsApp Phone Number (with country code)</label>
                                        <div className="relative">
                                            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm font-bold">+</span>
                                            <input
                                                type="text"
                                                name="whatsapp_number"
                                                value={socialForm.whatsapp_number}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/[^0-9]/g, '');
                                                    setSocialForm(prev => ({ ...prev, whatsapp_number: val }));
                                                }}
                                                className="w-full pl-8 pr-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:outline-none text-sm"
                                                placeholder="919901376188"
                                            />
                                        </div>
                                        <p className="text-[10px] text-gray-400 mt-1">Example: 919901376188 (91 = India country code + number)</p>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-600 mb-1.5">Auto Message (pre-filled in chat)</label>
                                        <textarea
                                            name="whatsapp_message"
                                            value={socialForm.whatsapp_message}
                                            onChange={handleSocialFormChange}
                                            rows={3}
                                            className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:outline-none text-sm resize-none"
                                            placeholder="Hello! I would like to know more about your products."
                                        />
                                        <p className="text-[10px] text-gray-400 mt-1">This message will be auto-filled when someone clicks the WhatsApp icon</p>
                                    </div>
                                    <div className="p-3 bg-green-50 border border-green-100 rounded-xl">
                                        <p className="text-[11px] text-green-800 font-medium flex items-center gap-1.5">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                                            On mobile → opens WhatsApp app directly &nbsp;|&nbsp; On desktop → opens WhatsApp Web
                                        </p>
                                    </div>
                                </>
                            ) : (
                                <div>
                                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                                        {SOCIAL_PLATFORMS.find(p => p.value === socialForm.platform)?.handleLabel || 'Username / Handle'}
                                    </label>
                                    <div className="relative">
                                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm font-medium">
                                            {SOCIAL_PLATFORMS.find(p => p.value === socialForm.platform)?.prefix.replace('https://', '')}
                                        </span>
                                        <input
                                            type="text"
                                            name="username"
                                            value={socialForm.username}
                                            onChange={handleSocialFormChange}
                                            className="w-full pr-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-pink-500 focus:outline-none text-sm"
                                            style={{ paddingLeft: `${(SOCIAL_PLATFORMS.find(p => p.value === socialForm.platform)?.prefix.replace('https://', '').length || 0) * 8 + 32}px` }}
                                            placeholder="username"
                                        />
                                    </div>
                                    <p className="text-[10px] text-gray-400 mt-1">Just enter your handle/ID, we'll build the full link for you</p>
                                </div>
                            )}
                            <div className="flex items-center gap-4">
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={parseInt(socialForm.is_active) === 1}
                                        onChange={(e) => setSocialForm(prev => ({ ...prev, is_active: e.target.checked ? 1 : 0 }))}
                                        className="w-4 h-4 accent-pink-600 rounded"
                                    />
                                    <span className="text-sm font-medium text-gray-700">Active (visible in footer)</span>
                                </label>
                            </div>
                            <div className="flex gap-3 pt-2">
                                <button
                                    onClick={handleSaveSocialLink}
                                    disabled={savingSocial}
                                    className="px-6 py-2 bg-pink-600 text-white font-semibold rounded-xl hover:bg-pink-700 transition flex items-center gap-2 disabled:opacity-50 text-sm"
                                >
                                    <Save size={16} /> {savingSocial ? 'Saving...' : (editingSocialLink ? 'Update Link' : 'Add Link')}
                                </button>
                                <button
                                    onClick={resetSocialForm}
                                    className="px-6 py-2 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition text-sm"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Links List */}
                    {loadingSocial ? (
                        <div className="text-center py-8 text-gray-400 text-sm">Loading social links...</div>
                    ) : socialLinks.length === 0 ? (
                        <div className="text-center py-12 text-gray-400">
                            <Share2 size={40} className="mx-auto mb-3 opacity-30" />
                            <p className="font-medium">No social links added yet</p>
                            <p className="text-xs mt-1">Click "Add Link" to add your first social media link</p>
                        </div>
                    ) : (
                        <div className="space-y-2">
                            {socialLinks.map((link) => (
                                <div
                                    key={link.id}
                                    className={`flex items-center gap-4 p-4 rounded-xl border transition-all ${
                                        parseInt(link.is_active) === 1
                                            ? 'bg-white border-gray-100 hover:border-pink-200 hover:shadow-sm'
                                            : 'bg-gray-50 border-gray-100 opacity-60'
                                    }`}
                                >
                                    {/* Platform Icon */}
                                    <div
                                        className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                                        style={{ backgroundColor: getPlatformColor(link.platform) + '18' }}
                                    >
                                        <SocialIcon platform={link.platform} color={getPlatformColor(link.platform)} size={20} />
                                    </div>

                                    {/* Info */}
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-2">
                                            <span className="font-bold text-sm text-gray-900">{getPlatformLabel(link.platform)}</span>
                                            {parseInt(link.is_active) === 1 ? (
                                                <span className="text-[10px] font-bold px-2 py-0.5 bg-green-100 text-green-700 rounded-full uppercase">Active</span>
                                            ) : (
                                                <span className="text-[10px] font-bold px-2 py-0.5 bg-gray-200 text-gray-500 rounded-full uppercase">Inactive</span>
                                            )}
                                            {link.display_order > 0 && (
                                                <span className="text-[10px] font-bold px-2 py-0.5 bg-blue-50 text-blue-600 rounded-full flex items-center gap-1">
                                                    <GripVertical size={10} /> #{link.display_order}
                                                </span>
                                            )}
                                        </div>
                                        <a href={link.url} target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-pink-600 truncate max-w-md mt-0.5 flex items-center gap-1">
                                            {link.url} <ExternalLink size={10} />
                                        </a>
                                    </div>

                                    {/* Actions */}
                                    <div className="flex items-center gap-1.5 flex-shrink-0">
                                        <button
                                            onClick={() => handleToggleSocialLink(link)}
                                            className="p-2 rounded-lg hover:bg-gray-100 transition"
                                            title={parseInt(link.is_active) === 1 ? 'Deactivate' : 'Activate'}
                                        >
                                            {parseInt(link.is_active) === 1 ? (
                                                <ToggleRight size={20} className="text-green-600" />
                                            ) : (
                                                <ToggleLeft size={20} className="text-gray-400" />
                                            )}
                                        </button>
                                        <button
                                            onClick={() => handleEditSocialLink(link)}
                                            className="p-2 rounded-lg hover:bg-blue-50 text-gray-400 hover:text-blue-600 transition"
                                            title="Edit"
                                        >
                                            <Pencil size={16} />
                                        </button>
                                        <button
                                            onClick={() => handleDeleteSocialLink(link.id)}
                                            className="p-2 rounded-lg hover:bg-red-50 text-gray-400 hover:text-red-600 transition"
                                            title="Delete"
                                        >
                                            <Trash2 size={16} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Security Settings */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 space-y-6">
                    <div className="flex items-center gap-3 border-b border-gray-100 pb-4">
                        <Lock className="text-red-600" size={24} />
                        <h3 className="text-lg font-bold text-gray-900">Panel Security</h3>
                    </div>

                    <div className="max-w-md">
                        <div className="p-4 bg-red-50 border border-red-100 rounded-2xl mb-6">
                            <p className="text-xs text-red-800 font-medium">
                                This 4-digit PIN protects your admin panel from unauthorized access during an active session.
                                Default PIN is 1234.
                            </p>
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">Admin Security PIN (4 Digits)</label>
                            <div className="relative">
                                <input
                                    type="text"
                                    name="admin_security_pin"
                                    value={localSettings.admin_security_pin || ''}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '').slice(0, 4);
                                        setLocalSettings({ ...localSettings, admin_security_pin: val });
                                    }}
                                    placeholder="Enter 4 digit PIN"
                                    className="w-full px-12 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-red-500 focus:outline-none font-bold tracking-[0.5em] text-lg"
                                />
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                            </div>
                            <p className="mt-2 text-[10px] text-gray-500 font-bold uppercase tracking-wider">Only numeric digits are allowed</p>
                        </div>
                    </div>

                    <div className="flex justify-end">
                        <button
                            onClick={handlePinUpdateClick}
                            disabled={savingSettings}
                            className="px-6 py-2 bg-red-600 text-white font-semibold rounded-xl hover:bg-red-700 transition flex items-center gap-2 disabled:opacity-50"
                        >
                            <Save size={18} /> {savingSettings ? 'Verifying PIN...' : 'Update PIN'}
                        </button>
                    </div>
                </div>
            </div>

            <AdminPinModal
                isOpen={showPinModal}
                onClose={() => setShowPinModal(false)}
                onSuccess={onVerifySuccessForPinChange}
                secretPin="9696"
            />
        </Layout>
    );
};

export default Settings;


